import { Injectable } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subject } from 'rxjs';
import { AuthService } from 'src/app/authentication/services/auth.service';
import { apiRoutes } from 'src/app/constants/apiRoutes';
import { ApiCallMethodsService } from 'src/app/shared/services/api-call-methods.service';
import { LoaderService } from 'src/app/shared/services/loader-service/loader-service.service';
import { SharedService } from 'src/app/shared/services/shared-service/shared.service';

@Injectable({
  providedIn: 'root'
})
export class SellService {
  orgId: any = null;
  invoiceListData: any = null;
  pageSizeOptions: number[] = [10, 20, 50, 100];
  // isLoading: boolean = false;

  csvStartDate: any = '';
  csvEndDate: any = '';
  sellPageIndex: number = 0;
  sellPageSize: number = 10;
  SharingData = new Subject();
  hasChanges: boolean = false;
  startFilterDate: any = null;
  endFilterDate: any = null;
  payload: any = {};

  //PAYMENT
  paymentList: any = null;
  paymentNewList: any = null;
  totalListCount: any = null;
  paymentPayload: any = {};
  paymentPageIndex: number = 0;
  paymentPageSize: number = 10;
  paidAmount: any;
  userDetails: any;
  oneInvoiceDetails: any;

  constructor(
    private authService: AuthService,
    private loaderService: NgxUiLoaderService,
    private apiCallMethodsService: ApiCallMethodsService,
    private sharedService: SharedService,

  ) {
    this.orgId = this.authService.getId();
    this.userDetails = this.authService.getSessionDetail();

    this.sharedService.dateFilterUpdated.subscribe((data: any) => {
      this.csvStartDate = data?.start;
      this.csvEndDate = data?.end;

      if (this.invoiceListData && data?.from == 'sell-list' && (data?.start || data?.remove == true)) {
        this.payload.date_range.start = data?.start;
        this.payload.date_range.end = data?.end;

        this.getInvoiceList(0, 10, this.payload);
      }

      if (this.paymentList && data?.from == 'payment-list' && (data?.start || data?.remove == true)) {
        this.paymentPayload.startDate = data?.start;
        this.paymentPayload.endDate = data?.end;

        this.getNewPaymentList(0, 10, this.paymentPayload);

      }

    });

    this.sharedService.customerFilterUpdated.subscribe((data: any) => {
      console.log(data);

      if (this.invoiceListData && data?.customerFrom == 'cus-sell-list' && (data?.id || data?.remove == true)) {
        this.payload.customer = data?.id;
        this.getInvoiceList(0, 10, this.payload);

      }

      if (this.paymentList && data?.customerFrom == 'payment-sell-list' && (data?.id || data?.remove == true)) {
        this.paymentPayload.customer = data?.id;
        this.getNewPaymentList(0, 10, this.paymentPayload);
      }

    });

    this.sharedService.ageSortUpdated.subscribe((data: any) => {

      if (this.invoiceListData && data?.from == 'age-sell-list' && (data?.overdue_days || data?.remove == true)) {
        this.payload.overdue_days = data?.overdue_days;
        this.getInvoiceList(0, 10, this.payload);

      }


    });
  }


  getInvoiceList(pageNumber, rowsPerPage, payload: any = null) {
    this.sellPageIndex = pageNumber;
    this.sellPageSize = rowsPerPage;
    this.payload = payload;

    let url = `${apiRoutes.invoiceListSortingAndFilter}/${this.orgId}?page=${pageNumber}&pagesize=${rowsPerPage}`;

    this.apiCallMethodsService.post(url, payload).subscribe((response: any) => {

      let data;

      this.invoiceListData = response;

      data = {
        invoiceData: this.invoiceListData,
      }

      this.SharingData.next(data);

    },
      (error: any) => {

        let data = {
          attendence: this.invoiceListData,
        }

        this.SharingData.next(data);
      });

  };

  getNewPaymentList(pageNumber, pageSize, newPayload: any = null) {

    this.paymentPageIndex = pageNumber;
    this.paymentPageSize = pageSize;
    this.paymentPayload = newPayload

    let url = `${apiRoutes.sellPayment}/${this.orgId}?page=${pageNumber}&pagesize=${pageSize}`;

    this.apiCallMethodsService.post(url, newPayload).subscribe((response: any) => {

      let data;

      this.paymentList = response;

      data = {
        paymentData: this.paymentList,
      }

      this.SharingData.next(data);

    },
      (error: any) => {

        let data = {
          paymentData: this.paymentList,
        }

        this.SharingData.next(data);

      });
  };


  // SELL MANAGEMENT DETAILS

    getInvoiceDetails(invoiceId: any = null) {
    let url = apiRoutes.getOneIqp + '/' + invoiceId + '?org_id=' + this.orgId + '&user_id=' + this.userDetails?.user?.user_id;
    this.apiCallMethodsService.get(url).subscribe((response: any) => {
     
      let data;
     
      this.oneInvoiceDetails = response?.data[0];

     data = {
        invData: this.oneInvoiceDetails,
      }

      this.SharingData.next(data);

    },
      (error: any) => {

        let data = {
          invData: this.oneInvoiceDetails,
        }

        this.SharingData.next(data);

      });

  };

  paymentDataTable(invoiceId) {
    let url = apiRoutes.amountList + '/' + invoiceId;
    this.apiCallMethodsService.get(url).subscribe((response: any) => {
      let data;

      this.paidAmount = response?.data;

      data = {
        payment: this.paidAmount,
      }

      this.SharingData.next(data);

    },
      (error: any) => {

        let data = {
          payment: this.paidAmount,
        }

        this.SharingData.next(data);

      });
  };


}
